// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg viewBox=%270 0 200 200%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cfilter id=%27n%27%3E%3CfeTurbulence type=%27fractalNoise%27 baseFrequency=%270.85%27 numOctaves=%274%27 stitchTiles=%27stitch%27/%3E%3C/filter%3E%3Crect width=%27100%25%27 height=%27100%25%27 filter=%27url%28%23n%29%27 opacity=%271%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* App.css - Additional styles for Lirk Print */

* {
  box-sizing: border-box;
}

.App {
  min-height: 100vh;
}

/* ─── Transitions ──────────────────────────────────────────── */
a, button {
  transition-property: color, background-color, border-color, opacity, transform, box-shadow;
  transition-timing-function: cubic-bezier(0.25, 0.1, 0.25, 1);
  transition-duration: 200ms;
}

/* ─── Showroom Card Glow ─────────────────────────────────── */
.showroom-card {
  border: 1px solid transparent;
  background: transparent;
  transition: border-color 0.35s ease, box-shadow 0.35s ease, transform 0.35s ease;
}

/* Dark mode hover glow – white */
.dark .showroom-card:hover {
  border-color: rgba(255, 255, 255, 0.25);
  box-shadow:
    0 0 0 1px rgba(255, 255, 255, 0.12),
    0 0 40px 4px rgba(255, 255, 255, 0.10),
    0 0 80px 10px rgba(255, 255, 255, 0.05),
    0 24px 60px -16px rgba(0, 0, 0, 0.7);
  transform: translateY(-2px);
}

/* Light mode hover glow – black */
html:not(.dark) .showroom-card:hover {
  border-color: rgba(0, 0, 0, 0.22);
  box-shadow:
    0 0 0 1px rgba(0, 0, 0, 0.10),
    0 0 40px 4px rgba(0, 0, 0, 0.08),
    0 0 80px 10px rgba(0, 0, 0, 0.04),
    0 24px 60px -16px rgba(0, 0, 0, 0.25);
  transform: translateY(-2px);
}

/* Ambient glow pulse for featured cards – dark only */
.dark .showroom-card.featured-glow {
  animation: featuredGlow 3.5s ease-in-out infinite;
}

html:not(.dark) .showroom-card.featured-glow {
  animation: featuredGlowLight 3.5s ease-in-out infinite;
}

@keyframes featuredGlow {
  0%, 100% {
    box-shadow:
      0 0 0 1px rgba(255, 255, 255, 0.07),
      0 0 24px 2px rgba(255, 255, 255, 0.05);
  }
  50% {
    box-shadow:
      0 0 0 1px rgba(255, 255, 255, 0.18),
      0 0 48px 6px rgba(255, 255, 255, 0.12),
      0 0 90px 12px rgba(255, 255, 255, 0.05);
  }
}

@keyframes featuredGlowLight {
  0%, 100% {
    box-shadow:
      0 0 0 1px rgba(0, 0, 0, 0.07),
      0 0 24px 2px rgba(0, 0, 0, 0.04);
  }
  50% {
    box-shadow:
      0 0 0 1px rgba(0, 0, 0, 0.16),
      0 0 48px 6px rgba(0, 0, 0, 0.08);
  }
}

/* ─── Showroom Grid ────────────────────────────────────────── */
.showroom-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
}

@media (max-width: 1024px) {
  .showroom-grid { grid-template-columns: repeat(2, 1fr); }
}

@media (max-width: 640px) {
  .showroom-grid { grid-template-columns: 1fr; }
}

.showroom-grid .span-2 {
  grid-column: span 2;
}

@media (max-width: 640px) {
  .showroom-grid .span-2 { grid-column: span 1; }
}

/* ─── Hero ──────────────────────────────────────────────────── */
.hero-title {
  background: linear-gradient(135deg, hsl(var(--foreground)) 0%, hsl(var(--muted-foreground)) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* ─── Card hover glow ─────────────────────────────────────── */
.card-glow {
  position: relative;
  isolation: isolate;
}

.card-glow::before {
  content: '';
  position: absolute;
  inset: -1px;
  border-radius: inherit;
  background: linear-gradient(135deg, transparent 0%, rgba(255,255,255,0.08) 100%);
  opacity: 0;
  transition: opacity 0.5s ease;
  z-index: -1;
}

.card-glow:hover::before {
  opacity: 1;
}

/* ─── Scroll animations ────────────────────────────────────── */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(24px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.animate-fade-in {
  animation: fadeIn 0.6s ease forwards;
}

.animate-fade-up {
  animation: fadeInUp 0.7s cubic-bezier(0.25, 0.1, 0.25, 1) forwards;
}

/* ─── Skeleton loader ─────────────────────────────────────── */
.skeleton {
  background: linear-gradient(
    90deg,
    hsl(var(--muted)) 25%,
    hsl(var(--accent)) 50%,
    hsl(var(--muted)) 75%
  );
  background-size: 200% 100%;
  animation: skeleton-shimmer 1.5s infinite;
}

@keyframes skeleton-shimmer {
  0% { background-position: 200% 0; }
  100% { background-position: -200% 0; }
}

/* ─── Floating animation ─────────────────────────────────── */
@keyframes float {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-8px); }
}

.animate-float {
  animation: float 4s ease-in-out infinite;
}

/* ─── Grain overlay ─────────────────────────────────────── */
body::after {
  content: '';
  position: fixed;
  inset: 0;
  pointer-events: none;
  z-index: 9999;
  opacity: 0.02;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 200px;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;EACE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,iEAAiE;AACjE;EACE,0FAA0F;EAC1F,4DAA4D;EAC5D,0BAA0B;AAC5B;;AAEA,+DAA+D;AAC/D;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,gFAAgF;AAClF;;AAEA,iCAAiC;AACjC;EACE,uCAAuC;EACvC;;;;wCAIsC;EACtC,2BAA2B;AAC7B;;AAEA,kCAAkC;AAClC;EACE,iCAAiC;EACjC;;;;yCAIuC;EACvC,2BAA2B;AAC7B;;AAEA,sDAAsD;AACtD;EACE,iDAAiD;AACnD;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE;IACE;;4CAEwC;EAC1C;EACA;IACE;;;6CAGyC;EAC3C;AACF;;AAEA;EACE;IACE;;sCAEkC;EACpC;EACA;IACE;;sCAEkC;EACpC;AACF;;AAEA,iEAAiE;AACjE;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,iBAAiB,qCAAqC,EAAE;AAC1D;;AAEA;EACE,iBAAiB,0BAA0B,EAAE;AAC/C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB,mBAAmB,EAAE;AAChD;;AAEA,kEAAkE;AAClE;EACE,iGAAiG;EACjG,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA,gEAAgE;AAChE;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,gFAAgF;EAChF,UAAU;EACV,6BAA6B;EAC7B,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA,iEAAiE;AACjE;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kEAAkE;AACpE;;AAEA,gEAAgE;AAChE;EACE;;;;;GAKC;EACD,0BAA0B;EAC1B,yCAAyC;AAC3C;;AAEA;EACE,KAAK,2BAA2B,EAAE;EAClC,OAAO,4BAA4B,EAAE;AACvC;;AAEA,+DAA+D;AAC/D;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,2BAA2B,EAAE;AACrC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,8DAA8D;AAC9D;EACE,WAAW;EACX,eAAe;EACf,QAAQ;EACR,oBAAoB;EACpB,aAAa;EACb,aAAa;EACb,yDAAiU;EACjU,sBAAsB;AACxB","sourcesContent":["/* App.css - Additional styles for Lirk Print */\n\n* {\n  box-sizing: border-box;\n}\n\n.App {\n  min-height: 100vh;\n}\n\n/* ─── Transitions ──────────────────────────────────────────── */\na, button {\n  transition-property: color, background-color, border-color, opacity, transform, box-shadow;\n  transition-timing-function: cubic-bezier(0.25, 0.1, 0.25, 1);\n  transition-duration: 200ms;\n}\n\n/* ─── Showroom Card Glow ─────────────────────────────────── */\n.showroom-card {\n  border: 1px solid transparent;\n  background: transparent;\n  transition: border-color 0.35s ease, box-shadow 0.35s ease, transform 0.35s ease;\n}\n\n/* Dark mode hover glow – white */\n.dark .showroom-card:hover {\n  border-color: rgba(255, 255, 255, 0.25);\n  box-shadow:\n    0 0 0 1px rgba(255, 255, 255, 0.12),\n    0 0 40px 4px rgba(255, 255, 255, 0.10),\n    0 0 80px 10px rgba(255, 255, 255, 0.05),\n    0 24px 60px -16px rgba(0, 0, 0, 0.7);\n  transform: translateY(-2px);\n}\n\n/* Light mode hover glow – black */\nhtml:not(.dark) .showroom-card:hover {\n  border-color: rgba(0, 0, 0, 0.22);\n  box-shadow:\n    0 0 0 1px rgba(0, 0, 0, 0.10),\n    0 0 40px 4px rgba(0, 0, 0, 0.08),\n    0 0 80px 10px rgba(0, 0, 0, 0.04),\n    0 24px 60px -16px rgba(0, 0, 0, 0.25);\n  transform: translateY(-2px);\n}\n\n/* Ambient glow pulse for featured cards – dark only */\n.dark .showroom-card.featured-glow {\n  animation: featuredGlow 3.5s ease-in-out infinite;\n}\n\nhtml:not(.dark) .showroom-card.featured-glow {\n  animation: featuredGlowLight 3.5s ease-in-out infinite;\n}\n\n@keyframes featuredGlow {\n  0%, 100% {\n    box-shadow:\n      0 0 0 1px rgba(255, 255, 255, 0.07),\n      0 0 24px 2px rgba(255, 255, 255, 0.05);\n  }\n  50% {\n    box-shadow:\n      0 0 0 1px rgba(255, 255, 255, 0.18),\n      0 0 48px 6px rgba(255, 255, 255, 0.12),\n      0 0 90px 12px rgba(255, 255, 255, 0.05);\n  }\n}\n\n@keyframes featuredGlowLight {\n  0%, 100% {\n    box-shadow:\n      0 0 0 1px rgba(0, 0, 0, 0.07),\n      0 0 24px 2px rgba(0, 0, 0, 0.04);\n  }\n  50% {\n    box-shadow:\n      0 0 0 1px rgba(0, 0, 0, 0.16),\n      0 0 48px 6px rgba(0, 0, 0, 0.08);\n  }\n}\n\n/* ─── Showroom Grid ────────────────────────────────────────── */\n.showroom-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 1rem;\n}\n\n@media (max-width: 1024px) {\n  .showroom-grid { grid-template-columns: repeat(2, 1fr); }\n}\n\n@media (max-width: 640px) {\n  .showroom-grid { grid-template-columns: 1fr; }\n}\n\n.showroom-grid .span-2 {\n  grid-column: span 2;\n}\n\n@media (max-width: 640px) {\n  .showroom-grid .span-2 { grid-column: span 1; }\n}\n\n/* ─── Hero ──────────────────────────────────────────────────── */\n.hero-title {\n  background: linear-gradient(135deg, hsl(var(--foreground)) 0%, hsl(var(--muted-foreground)) 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n/* ─── Card hover glow ─────────────────────────────────────── */\n.card-glow {\n  position: relative;\n  isolation: isolate;\n}\n\n.card-glow::before {\n  content: '';\n  position: absolute;\n  inset: -1px;\n  border-radius: inherit;\n  background: linear-gradient(135deg, transparent 0%, rgba(255,255,255,0.08) 100%);\n  opacity: 0;\n  transition: opacity 0.5s ease;\n  z-index: -1;\n}\n\n.card-glow:hover::before {\n  opacity: 1;\n}\n\n/* ─── Scroll animations ────────────────────────────────────── */\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(24px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n.animate-fade-in {\n  animation: fadeIn 0.6s ease forwards;\n}\n\n.animate-fade-up {\n  animation: fadeInUp 0.7s cubic-bezier(0.25, 0.1, 0.25, 1) forwards;\n}\n\n/* ─── Skeleton loader ─────────────────────────────────────── */\n.skeleton {\n  background: linear-gradient(\n    90deg,\n    hsl(var(--muted)) 25%,\n    hsl(var(--accent)) 50%,\n    hsl(var(--muted)) 75%\n  );\n  background-size: 200% 100%;\n  animation: skeleton-shimmer 1.5s infinite;\n}\n\n@keyframes skeleton-shimmer {\n  0% { background-position: 200% 0; }\n  100% { background-position: -200% 0; }\n}\n\n/* ─── Floating animation ─────────────────────────────────── */\n@keyframes float {\n  0%, 100% { transform: translateY(0); }\n  50% { transform: translateY(-8px); }\n}\n\n.animate-float {\n  animation: float 4s ease-in-out infinite;\n}\n\n/* ─── Grain overlay ─────────────────────────────────────── */\nbody::after {\n  content: '';\n  position: fixed;\n  inset: 0;\n  pointer-events: none;\n  z-index: 9999;\n  opacity: 0.02;\n  background-image: url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='1'/%3E%3C/svg%3E\");\n  background-size: 200px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
